import * as api from "util/api";
import { DateMetaData } from "burde";

export const getMetadata = async (
    culture: string,
    fromDate: string,
    numberOfWeeks: number,
) => {
    let days: DateMetaData[];

    try {
        const { success, data, message } = await api.json.get(
            "api/calendar/metadata/getmetadata",
            {
                culture,
                fromDate,
                numberOfWeeks,
            },
        );

        if (!success) {
            throw message;
        }

        days = data;

        if (days === null || days === undefined || !Array.isArray(days)) {
            return null;
        }

        return days;
    } catch {
        // nothing
    }
};
